import { FadeUp } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Awakening",
    text: "On his eighteenth birthday, Alex McLeod discovers a secret pulsing in his veins — the aurora borealis has chosen him. Sparks dance at his fingertips, shields flare from nowhere, and Toronto itself hums when he walks its streets. Alex just wants to stay invisible. But the world has other plans.",
  },
  {
    n: "02",
    title: "The Hunt",
    text: "A ruthless energy mogul will stop at nothing to harness Alex's power for his own machine. A covert Canadian agency hunts him under the promise of \u201cbelonging\u201d — their red-dot map spreading across the nation.",
  },
  {
    n: "03",
    title: "The Cost",
    text: "Mentored by a scarred ex-agent who warns that every gift has a cost, Alex must decide: stay hidden and risk losing everyone he loves, or step into the light and embrace a destiny he never asked for.",
  },
];

export const Story = () => (
  <section id="story" data-testid="story-section" className="relative py-28 md:py-36">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <FadeUp>
        <div className="flex items-baseline justify-between flex-wrap gap-4">
          <span className="font-tech text-[11px] uppercase tracking-[0.3em] text-emerald-400">
            The Story
          </span>
          <span className="font-tech text-[11px] uppercase tracking-[0.3em] text-zinc-600">
            Coming of Age / Canadian Fantasy
          </span>
        </div>
        <h2 className="font-display font-light tracking-tighter leading-[1.02] text-[clamp(2.2rem,4.6vw,4.5rem)] mt-8 max-w-3xl">
          A storm is rising <span className="italic text-zinc-400">over Toronto.</span>
        </h2>
      </FadeUp>

      <div className="mt-20">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.n} delay={i * 0.08} y={40}>
            <article
              data-testid={`story-chapter-${i + 1}`}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 border-t border-white/10 py-12 md:py-16 hover:bg-white/[0.02] transition-[background-color,padding] duration-500 hover:md:pl-6"
            >
              <div className="md:col-span-2 font-tech text-emerald-500/80 text-sm tracking-[0.3em] pt-3">
                {c.n}
              </div>
              <h3 className="md:col-span-4 font-display font-light italic tracking-tight text-3xl md:text-5xl leading-tight text-white group-hover:text-emerald-300 transition-colors duration-500">
                {c.title}
              </h3>
              <p className="md:col-span-6 text-zinc-400 font-light leading-relaxed text-base md:text-lg">
                {c.text}
              </p>
            </article>
          </FadeUp>
        ))}
      </div>

      <FadeUp delay={0.1}>
        <blockquote className="mt-20 max-w-4xl border-l-2 border-emerald-500 pl-8 md:pl-12 py-2">
          <p className="font-display font-light italic tracking-tight text-2xl md:text-4xl leading-snug text-zinc-200">
            &ldquo;Perfect for fans of Percy Jackson and The Umbrella Academy — a coming-of-age
            story about power, identity, and the price of choosing who you&rsquo;ll become.&rdquo;
          </p>
          <cite className="not-italic font-tech text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-6 block">
            Alex McLeod is no longer a ghost — he&rsquo;s Canada&rsquo;s first reluctant protector.
          </cite>
        </blockquote>
      </FadeUp>
    </div>
  </section>
);

export default Story;
